import { onMounted, reactive } from 'vue'
import {
  pkg_list_post,
  pkg_release_get,
  pkg_download_package_get,
  pkg_releaseApp_get
  // page_utils_page_version_update as version_update,
  // page_utils_page_version_push as version_push,
  // page_utils_page_version_list as version_list
} from '@/server/modules/9002.js'
import { Modal, message } from 'ant-design-vue'

export const useRelease = () => {
  const state = reactive({
    pagination: {
      current: 1, //当前页数 v-model
      defaultPageSize: 10,
      defaultCurrent: 1, //默认的当前页数
      pageSize: 10, //每页显示几条数据
      showQuickJumper: true, //是否显示直通车
      total: 0, //总数
      pageSizeOptions: ['10', '20', '50', '100'],
      showSizeChanger: true,
      showLessItems: true,
      onShowSizeChange: (current, pageSize) => {
        state.pagination.current = current
        state.pagination.pageSize = pageSize
        state.initList()
      },
      onChange: (current, pageSize) => {
        state.pagination.current = current
        state.pagination.pageSize = pageSize
        state.initList()
      },
      showTotal: total => `共 ${total} 条数据`
    },
    formItemLayout: {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    },
    activeKey: '1',
    formState: {
      version: ''
    },
    dataSource: [],
    handleQuery: () => {
      state.pagination.current = 1
      state.initList()
    },

    initList: async () => {
      const params = {
        version: state.formState.version,
        pageNum: state.pagination.current,
        pageSize: state.pagination.pageSize,
        terminalId: state.activeKey
      }
      let { success, data, retInfo } = await pkg_list_post(params)
      if (success) {
        state.dataSource = data.list
        state.pagination.total = data.total
      } else {
        message.error(retInfo)
      }
    },
    handleRelease: async () => {
      Modal.confirm({
        title: '提示',
        content: '确认发布吗?',
        onOk: async () => {
          const actions =
            state.activeKey === '1' ? pkg_release_get : pkg_releaseApp_get
          const { success, retInfo } = await actions()
          // const { success: listSuccess, data } = await version_list()
          // if (listSuccess) {
          //   const newVersion =
          //     data
          //       .find(item => item.name.toLocaleUpperCase() === 'I18N')
          //       .version.split('.').length < 4
          //       ? data
          //           .find(item => item.name.toLocaleUpperCase() === 'I18N')
          //           .version.split('.')
          //       : [12, 1, 3]

          //   const id = data.find(
          //     item => item.name.toLocaleUpperCase() === 'I18N'
          //   ).id

          //   newVersion[2] = Number(newVersion[2]) + 1
          //   if (newVersion[2] > 99) {
          //     newVersion[1] = Number(newVersion[1]) + 1
          //     newVersion[2] = 0
          //   }
          //   if (newVersion[1] > 99) {
          //     newVersion[0] = Number(newVersion[0]) + 1
          //     newVersion[1] = 0
          //   }

          //   const i18nVersion = newVersion.join('.')
          //   const {
          //     success: versionSuccess,
          //     retInfo: versionRetInfo
          //   } = await version_update(
          //     {
          //       name: 'i18n',
          //       version: i18nVersion,
          //       fid: '0',
          //       status: '1',
          //       description: '多语言版本号',
          //       operateUser: localStorage.getItem('userName') || 'admin'
          //     },
          //     {},
          //     id
          //   )
          //   if (versionSuccess) {
          //     const {
          //       success: pushsuccess,
          //       retInfo: pushretInfo,
          //       data
          //     } = await version_push({
          //       operateUser: localStorage.getItem('userName') || 'admin'
          //     })
          //     if (pushsuccess) {
          //       Modal.success({
          //         title: () => '发布成功',
          //         content: () => data.url
          //       })
          //     } else {
          //       message.error(pushretInfo)
          //     }
          //   } else {
          //     message.error(versionRetInfo)
          //   }
          // }
          if (success) {
            state.initList()
          } else {
            message.error(retInfo)
          }
        }
      })
    },
    columns: [],
    _columns: () => [
      {
        title: '发布时间',
        dataIndex: 'releaseTime',
        key: 'releaseTime',
        width: 150,
        resizable: true,
        align: 'center'
      },
      {
        title: '发布人',
        dataIndex: 'releaseUser',
        key: 'releaseUser',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '语言包版本号',
        dataIndex: 'version',
        key: 'version',
        resizable: true,
        align: 'center',
        width: 120
      }
    ],
    handleTabChange: e => {
      console.log('e', e)
      if (e === '1') {
        state.columns = state._columns()
      } else {
        const item = {
          title: '下载',
          key: 'download',
          resizable: true,
          align: 'center',
          width: 120
        }
        state.columns.push(item)
      }
      state.initList()
    },
    handleDownload: async record => {
      let { success, retInfo, data } = await pkg_download_package_get({
        packageId: record.id
      })
      if (success) {
        fetch(data.packageUrl)
          .then(res => res.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob)
            state.openDownLoad(url)
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        message.error(retInfo)
      }
    },
    openDownLoad: (url, name = 'app-i18n-resource') => {
      const aDom = document.createElement('a')
      aDom.style.display = 'none'
      aDom.href = url
      aDom.target = '_blank'
      aDom.download = name
      aDom.click()
      message.success('下载成功')
    }
  })
  onMounted(() => {
    state.columns = state._columns()
  })
  return state
}
